import React, { useState, useMemo } from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import AppTableContainer from "@crema/core/AppTableContainer";
import TableHeading from "./TableHeading";
import TableItem from "./TableItem";
import { NodelMasterData } from "types/models/nodelMaster/NodelMasterApp";

interface NodelTableProps {
  nodel: NodelMasterData[];
}

const NodelTable: React.FC<NodelTableProps> = ({ nodel }) => {
  const [order, setOrder] = useState<"asc" | "desc">("asc");
  const [orderBy, setOrderBy] = useState<keyof NodelMasterData>("customerId");

  const handleSort = (property: keyof NodelMasterData) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedNodels = useMemo(() => {
  return [...nodel].sort((a, b) => {
    const aVal = a[orderBy];
    const bVal = b[orderBy];

   if (aVal == null && bVal == null) return 0;
    if (aVal == null) return order === "asc" ? -1 : 1;
    if (bVal == null) return order === "asc" ? 1 : -1;

    if (typeof aVal === "number" && typeof bVal === "number") {
      return (aVal - bVal) * (order === "asc" ? 1 : -1);
    }

   return String(aVal).localeCompare(String(bVal)) * (order === "asc" ? 1 : -1);
  });
}, [nodel, order, orderBy]);


  return (
    <AppTableContainer>
      <Table stickyHeader className="table">
        <TableHead>
          <TableHeading order={order} orderBy={orderBy} onSort={handleSort} />
        </TableHead>
        <TableBody>
          {sortedNodels.map((data) => (
            <TableItem key={data.id} data={data} />
          ))}
        </TableBody>
      </Table>
    </AppTableContainer>
  );
};

export default NodelTable;
